<div style="color:#919191; margin-bottom: 5px;">
  Links estudios anteriores ({{ links?.length || 0 }})
</div>

<div *ngIf="links?.length; else noLinks" class="links-plain">
  <div class="link-item" *ngFor="let link of links">
    <a [href]="link" target="_blank" rel="noopener" [title]="link">{{ link }}</a>
  </div>
</div>

<ng-template #noLinks>
  <div class="no-links-warning">No hay links cargados.</div>
</ng-template>
